import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/authContext';
import ProtectedRoute from './components/ProtectedRoute';
import NavBar from './components/NavBar';
import UserButtons from './components/UserButtons';

import Home from './pages/Home';
import Explore from './pages/Explore';
import RecipeDetails from './pages/RecipeDetails';
import CreateRecipe from './pages/CreateRecipe';
import EditRecipe from './pages/EditRecipe';
import Login from './pages/Login';
import Register from './pages/Register';
import ProfilePage from './pages/ProfilePage';
import NotFound from './pages/NotFound';
import ForkRecipe from './pages/ForkRecipe';
import MyRecipes from './pages/MyRecipes';
import Collections from './pages/Collections';
import RecipeQuiz from './pages/RecipeQuiz';
import Nutrition from './pages/Nutrition';

function AppRoutes() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <div className="main-wrapper">
                    {/* Site Header with Stylized Title */}
                    <div className="site-header">
                        <h1 className="site-title">4rked</h1>
                        <p className="site-subtitle">Recipes n shit</p>
                        <UserButtons />
                    </div>

                    {/* Navigation Bar */}
                    <NavBar />

                    {/* Main Content Routes */}
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/explore" element={<Explore />} />
                        <Route path="/collections" element={<Collections />} />
                        <Route path="/quiz" element={<RecipeQuiz />} />
                        <Route path="/nutrition" element={<Nutrition />} />
                        <Route path="/recipe/:id" element={<RecipeDetails />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route 
                            path="/profile" 
                            element={
                                <ProtectedRoute>
                                    <ProfilePage />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/profile/:userId" 
                            element={
                                <ProtectedRoute>
                                    <ProfilePage />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/create" 
                            element={
                                <ProtectedRoute>
                                    <CreateRecipe />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/edit/:id" 
                            element={
                                <ProtectedRoute>
                                    <EditRecipe />
                                </ProtectedRoute>
                            } 
                        />
                        <Route path="/fork/:id" element={<ForkRecipe />} />
                        <Route path="/my-recipes" element={<MyRecipes />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </div>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default AppRoutes;